/** Dispatched from outside React (e.g. appUrlOpen) so the shell stays on https://localhost, not an external origin. */
export const INTERNAL_NAVIGATE_EVENT = 'skipdq:internal-navigate';

export function emitInternalNavigation(path = '/') {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent(INTERNAL_NAVIGATE_EVENT, { detail: { path } }),
  );
}
